/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {ExdsTheme} from "@exds/theme";
import {ExdsButton} from "@exds/core";
import { TuxModal } from '@tuxedo/react-component-library';
import React from "react";

export default function MissingAccessCodeExternalModal({isAccessCodeModalOpen, setIsAccessCodeModalOpen}) {
  return (
    <TuxModal
      className="modal-container"
      type='popup'
      title="Haven't received your code?"
      open={isAccessCodeModalOpen}
      onCloseModal={() => setIsAccessCodeModalOpen(false)}
      body={
        <ExdsTheme>
          <p>
            Your secondary code can take <b>up to 5 minutes to arrive</b> and will be sent to the phone number registered
            during your application process. Please also check your signal to your device.
          </p>
          <p>
            If you still haven't received your secondary code, speak to your onboarding facilitator to generate a new code.
          </p>
        </ExdsTheme>
      }
      footer={
        <ExdsTheme>
          <ExdsButton
            data-testid="close-modal-button"
            text="Close"
            variant="tertiary"
            className="modal-close-button"
            onClick={() => setIsAccessCodeModalOpen(false)}
          />
        </ExdsTheme>
      }
    />
  );
}
